import React from 'react';
import { createPortal } from 'react-dom';
import { Button as UiButton } from '../../ui/Button';

const FullColourModal = ({ 
    show, 
    onClose, 
    onConfirm, 
    isDark 
}) => {
    if (!show) return null;

    return createPortal(
        <div
            className="fixed inset-0 bg-black/80 flex items-center justify-center"
            style={{ zIndex: 99999 }}
            onClick={onClose}
        >
            <div
                className={`rounded-[12px] p-[32px] max-w-[400px] w-full mx-4 shadow-lg flex flex-col items-center gap-[24px] transition-colors duration-200 ${
                    isDark ? 'bg-[#161515]' : 'bg-white'
                }`}
                onClick={(e) => e.stopPropagation()}
            >
                <p className={`text-[16px] font-semibold text-center m-0 transition-colors duration-200 ${
                    isDark ? 'text-white' : 'text-[#072837]'
                }`}>
                    Are you sure, additional costs will be incurred for full colour?
                </p>
                <div className="flex gap-[16px] w-full">
                    <UiButton
                        variant="ghost"
                        className={`flex-1 text-[16px] px-[16px] py-[12px] rounded-[12px] transition-colors duration-200 ${
                            isDark 
                                ? 'bg-[#cd6d2c] text-[#000000] hover:bg-[#e37f3d]' 
                                : 'bg-[#cd6d2c] text-white hover:bg-[#b35d24]'
                        }`}
                        onClick={onConfirm}
                    >
                        Confirm
                    </UiButton>
                    <UiButton
                        variant="ghost"
                        className={`flex-1 text-[16px] px-[16px] py-[12px] rounded-[12px] transition-colors duration-200 ${
                            isDark 
                                ? 'bg-[#000000] text-[#ffffff] hover:bg-[#1a1a1a]' 
                                : 'bg-[#D9D9D9] text-[#072837] hover:bg-[#D9D9D9]'
                        }`}
                        onClick={onClose}
                    >
                        Cancel
                    </UiButton>
                </div>
            </div>
        </div>,
        document.body
    );
};

export default FullColourModal;
